import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { CardFooter } from "reactstrap";
import SneakerCard from "./SneakerCard";
import SneakerImage from "./SneakerImage";
import SneakerSummary from "./SneakerSummary";
import SneakerSize from "./SneakerSize";
import SneakerTitle from "./SneakerTitle";
import { TextRupiah } from "../Text";

import SneakerHeader from "./SneakerHeader";
import { getCacheImage } from "../../config";
import SneakerFooter from "./SneakerFooter";
import { normalizeBrand, getCloudImageUrl, categoryURL, categoryString, emptyImage } from "../../utils";
import emptySneakerImg from "../../images/emptysneakers2.png";
import emptyApparelImg from "../../images/emptyapparels.png";
import emptyHandbagImg from "../../images/emptyhandbags.png";

const urlProduct = props => {
  if (props.category === "sneakers")
    return `/sneakers/${props.id}/${props.slug}`;
  else if (props.category === "apparels")
    return `/apparels/${props.id}/${props.slug}`;
};

const FooterForYou = ({ display_name, category, latest_price, out_of_stock, total_subsidy }) => {
  return (
    <CardFooter
      className="wrapper-footer"
      style={{ background: "transparent", border: "none" }}
    >
      <div className="sneaker-price">
        <div className="price-tag-wrapper">
          <span className="price-tag">{display_name}</span>
        </div>
        {/* {
          category === "lifestyles" ?
            <div className="sub-category-wrapper">
              <span>
                {category ? category : ""}
              </span>
            </div>
          : null
        } */}
        {
          latest_price === 0 ?
          <div className="sneaker-price">
            <p
              className="text-danger text-center text-bold"
              style={{ margin: 0 }}
            >
              {out_of_stock ? "Out of Stock" : "Coming Soon"}
            </p>
          </div>
        :
        <>
          <TextRupiah
            value={total_subsidy > 0 ? total_subsidy : latest_price}
            prefix="IDR "
            className="price-tag"
            color="black"
            bold={true}
          />
        </>
        }
      </div>
    </CardFooter>
  )
}

export default function SneakerForYou(props) {
  const categoryUrl = categoryURL(props.category);
  const url = props.isPreVerified ? `/${categoryUrl}/${props.id}/${props.slug}?pre_verified=true&from=search` : (props.vintage ? `${categoryUrl}/${props.id}/${props.slug}?vintage=true&from=search` : `/${categoryUrl}/${props.id}/${props.slug}?from=search`);
  const hotProducts = props.hotProducts || props.editors_choice;

  return (
    <SneakerCard
      url={url}
      activeId={props.activeId}
      updateActiveId={props.updateActiveId}
      id={props.id}
      similarProducts={props.similarProducts}
      productPrice={props.latest_price}
    >
      <SneakerImage
        imageTitle={props.display_name}
        hasImage={props.image_url ? true : false}
        src={
          props.image_url
            ? getCloudImageUrl(props.image_url, 400)
            : emptyImage(categoryString(props.category))
        }
        alt={props.display_name}
        category={categoryString(props.category)}
        hotProducts={hotProducts}
      />
      <FooterForYou
        display_name={props.display_name}
        category={props.category}
        latest_price={props.latest_price}
        out_of_stock={props.out_of_stock}
        total_subsidy={props.total_subsidy}
      />
    </SneakerCard>
  );
}

const styles = {
  sizeUndefined: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center"
  }
};
